export default __webpack_public_path__ + "static/discover-f12fc7b90d111b1b4e20630e410e8309.svg";